import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { ShellComponent } from './layout/shell.component';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { MachinesComponent } from './pages/machines/machines.component';
import { MachineDetailComponent } from './pages/machine-detail/machine-detail.component';
import { TasksComponent } from './pages/tasks/tasks.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { AlertsComponent } from './pages/alerts/alerts.component';
import { ExtractionsComponent } from './pages/extractions/extractions.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'machines', component: MachinesComponent },
      { path: 'machines/:id', component: MachineDetailComponent },
      { path: 'tasks', component: TasksComponent },
      { path: 'calendar', component: CalendarComponent },
      { path: 'alerts', component: AlertsComponent },
      { path: 'extractions', component: ExtractionsComponent },
    ],
  },
  { path: '**', redirectTo: '' },
];
